import API, { handleRequest } from '@/api/lib/api'

export const getLoyaltyTemplates = params =>
  handleRequest(() =>
    API.get(`restaurant/${params.restaurant_id}/loyalty-templates`, { params })
  )

export const createLoyaltyTemplate = data =>
  handleRequest(() => API.post(`restaurant/loyalty-templates`, data))

export const updateLoyaltyTemplate = (template_id, data) =>
  handleRequest(() =>
    API.post(`restaurant/loyalty-templates/${template_id}`, data)
  )

export const deleteLoyaltyTemplate = template_id =>
  handleRequest(() => API.delete(`restaurant/loyalty-templates/${template_id}`))
